import React, { FC } from "react";
import { FormGroup, Input, Label } from "reactstrap";

export interface FilterRadioProps {
  id: string;
  name: string;
  checked: boolean;
  onChange: () => void;
  value: string;
  label: string;
  className: string;
}

const FilterRadio: FC<FilterRadioProps> = ({ id, name, checked, onChange, value, label, className }) => (
  <FormGroup className={`${className} filter-radio`} data-testid="filter-radio">
    <Label check className="filter-radio__label" for={id}>
      {label}
    </Label>
    <Input
      id={id}
      className="filter-radio__input"
      type="radio"
      checked={checked}
      onChange={onChange}
      value={value}
      name={name}
    />
  </FormGroup>
);

export default FilterRadio;
